export default __webpack_public_path__ + "static/media/logo.b1bc8257.png";